﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { PoleStockReview, PSRToken, PolePart, PSRDayToken, DailyToken, DailyTokenItem, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-pol-stk-rvw',
  templateUrl: './pol-stk-rvw.component.html',
  styleUrls: ['./pol-stk-rvw.component.css']
})
export class PolStkRvwComponent implements OnInit {
  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editParam1:any;
  editParam2:any;
  currMonthDtObj:Date = new Date();
  areChangesMade: boolean = false;
  dPSRDayTokenObj:PSRDayToken;
  selView: number = 1;
  productName:string = '';
  CopyPSRDayTokenObj:Array<PSRToken>=[];

  editRow:PSRToken;
  datatables:PoleStockReview;
  copyDataObj:PoleStockReview;

  polePartArray:Array<PolePart>;
  isFullScrDaySel:boolean = false;
  selectedDayIndex:number = 0; 

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';
  mId:string = "7371ba17-9f08-4da0-6fc0-f2f7c8686504";
  copySelDate:Date = new Date();
  daywiseItemList: Array<DailyToken>;

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild('copyModal') public copyModal:ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;
  
  constructor(private _dataService:DataService,
              private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }


  ngOnInit() {
    this._dataService.currPageName = "Pole Stock Review";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }
  private getDisplayTokenName(_ownerId:string,_resolDate:number){
    if(_resolDate){
      let _resolDate = '-'
    }
    return this._dataService.getProductName(_ownerId) + ' ('+_resolDate+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }

 hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadPoleStockRevw(this.currMonthDtObj).subscribe((_dataTables:PoleStockReview) => {
        if(_dataTables!=null){
          this.datatables = _dataTables;
          this.loadDateData();
    
          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.datatables.dayTokens.length; i++) {
            let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];
            
            let _indexer:number = 0;
            this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:PSRToken) => {
              _tmpDailyTokens.push(new DailyTokenItem(this.getDisplayTokenName(_tmpObj.productName,_tmpObj.quantity), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }
  loadDateData():void{
    let _tmpDPHDayToken:PSRDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.dPSRDayTokenObj = _tmpDPHDayToken;
  }
  public addNewProdRow(_newRowToken: string, _selDate: Date,indx: number) {
    switch (_newRowToken) {
      case "rownew":
        this.showChildModal(_newRowToken,null,null);
        break;
    }
  }
  public removeActionDecided(_tokenIndex:number){
    this.dPSRDayTokenObj.removeToken(_tokenIndex);
    this.areChangesMade = true;
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }
  sortPartNo(Pid:string){
    this.productName = Pid;
  }
  pullPartNo(Pid:string){
     this.polePartArray = [];
    for(var i=0;i<this._dataService.polePart.length;i++){
      if(this._dataService.polePart[i].productId == Pid){
        this.polePartArray.push(this._dataService.polePart[i])
      }
    }
    return this.polePartArray
  }
  discardData():void{
    this.loadMonthData();
  }
  copyData(){
    this.copyDataObj=null;
    this._dataService.getPoleCopyData(this.copySelDate).subscribe((_doc:PoleStockReview) => {
      if(_doc.dayTokens.length>0){  
        this.copyDataObj = _doc;
        this.loadCopyDateData();
      }
      else{
        this.CopyPSRDayTokenObj = [];
      }
    });
    this.copyModal.show();
  }
  dataCopied(){
    for(var i=0;i<this.CopyPSRDayTokenObj.length;i++){
      this.dPSRDayTokenObj.addToken(this.CopyPSRDayTokenObj[i])
    } 
    this.areChangesMade = true;
    this.discardCopyData(); 
      
  }
  discardCopyData(){    
    this.CopyPSRDayTokenObj=[];
    this.hideCopyChildModal()
  }
  hideCopyChildModal(){
    this.copyModal.hide()
  }
  openCopyModal(){       
    this.copySelDate = new Date(this.currMonthDtObj.getTime()) 
    this.copySelDate.setDate(this.copySelDate.getDate() - 1)
    this.copyData();
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }
  prevCopyDateSel():void{
    this.copySelDate.setDate(this.copySelDate.getDate()-1);
    this.copyData();
}
nextCopyDateSel():void{
    this.copySelDate.setDate(this.copySelDate.getDate()+1);
    this.copyData();
}
  getData(option){
    if(option) return option
    return ''
  }
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);    
    this.loadMonthData();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);    
    this.loadMonthData();
  }
  formatCopyHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  loadCopyDateData():void{
    this.CopyPSRDayTokenObj = [];
    if(this.copyDataObj.dayTokens[0]){
      for(var i=0;i<this.copyDataObj.dayTokens[0].dateTokens.length;i++){
        let temp = this.copyDataObj.dayTokens[0].dateTokens[i];
        this.CopyPSRDayTokenObj.push(new PSRToken(temp.productName,temp.poleDescPartNo,temp.quantity,(new Date()).getTime()))
      }
    }
  }
  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  getPoleDescPartNo(_pid:string,_id:string):string{
    if(_id) return this._dataService.getPoleDescPartNo(_pid,_id)
    return ''
  }
  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.editRow = _param1.cloneSelf();
      this.editType = _editToken;
      this.editHeader = "Edit Pole Stock Review (" + this.formatHeaderDate(this.dPSRDayTokenObj.selDate) +")";
      break;
      case "rownew":
      this.editRow = new PSRToken(null,null,null,(new Date()).getTime());
      this.editType = _editToken;
      this.editHeader = "Add Pole Stock Review (" + this.formatHeaderDate(this.dPSRDayTokenObj.selDate) +")";
      break;
      case "selplan":
        this.editText = this.datatables.plan;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  dataEdited(){
    switch(this.editToken){
      case "rowedit":    
        this.editParam1.productName = this.editRow.productName;
        this.editParam1.poleDescPartNo = this.editRow.poleDescPartNo;
        this.editParam1.quantity = this.editRow.quantity;
      break;
      case "rownew":
      this.datatables.addDateToken(new Date(this.currMonthDtObj),
                                     new PSRToken(this.editRow.productName,this.editRow.poleDescPartNo,this.editRow.quantity,this.editRow.creationDate));

      break;
      case "selplan":
        this.datatables.plan = this.editText;
      break;
    }
    this.areChangesMade = true;
    this.hideChildModal();
  }
  public hideChildModal():void {
    this.childModal.hide();
  }

  public discardSaveData():void {
    this.childModal.hide();
  }
  validateData():boolean{
    return true;
  }
  saveData(_sendMail:boolean):void{
    if(this.validateData()==true){
      this._dataService.savePoleStockRevw(this.datatables,_sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status == DataService.statusFail){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }

      });
    }
  }

}
